<script setup lang="ts">
  import { Picture } from '@travelata-libs/ui-kit';

  const onClick = () => {
    window.location.href = '/';
  };
</script>

<template>
  <Picture
    path="travelata/logo/logo-white-short.svg"
    :lazy="false"
    :extensions="[]"
    :high-resolution="false"
    fit="contain"
    class="picture-travelata-logo"
    @click.capture="onClick"
  />
</template>

<style scoped lang="scss">
  .picture-travelata-logo {
    cursor: pointer;
    height: 20px;
    width: 111px;
  }
</style>
